import Vue from 'vue';
import ZSourceSelector from '../components/ZSourceSelector'
import ZNotify from '../components/ZNotify'
import ZLoading from "../components/ZLoading"
import ZSelectMonth from "../components/ZSelectMonth"
import ZSelectDate from "../components/ZSelectDate"
import ZConfirm from "../components/ZConfirm"

function plugins(Vue) {
  Vue.component('z-source-selector',ZSourceSelector)
  Vue.component('z-notify',ZNotify)
  Vue.component('z-loading',ZLoading)
  Vue.component('z-select-month',ZSelectMonth)
  Vue.component('z-select-date',ZSelectDate)
  Vue.component('z-confirm',ZConfirm)

}

export default plugins